import {
  Component,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'cigna-filter-text-input',
  templateUrl: './filter-text-input.component.html',
  styleUrls: ['./filter-text-input.component.css'],
})
export class FilterTextInputComponent {
  @Input() text = '';
  @Input() placeholder = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() darkBg = false;
  @Output() inputChange = new EventEmitter();
  @ViewChild('textInput', { read: ElementRef, static: true })
  private textInput: ElementRef;

  get textInputValue(): string {
    return this.textInput.nativeElement.value;
  }

  public clearInput() {
    this.textInput.nativeElement.value = '';
    this.inputChange.emit('');
    this.textInput.nativeElement.focus();
  }
}
